import { ObjectId } from '@extrahorizon/javascript-sdk';
import { Select } from '@mantine/core';
import { useSearchPatientName } from 'hooks/api/useProfile';
import { useUserQuery } from 'hooks/api/useUser';
import { Dispatch, SetStateAction } from 'react';

interface Props {
  onChange: (value: string) => void;
  value?: string;
  placeholder?: string;
  defaultValue?: string;
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  testId?: string;
}

export const SelectWithSearch = ({ value, onChange, searchValue, setSearchValue, placeholder, testId }: Props) => {
  const { data: patientList = [] } = useSearchPatientName({ searchValue });
  // If no search query happened but there is a user id in the url
  // The select cannot match the selected user to a value
  // So we need to search for that id specifically and add it to the list
  const { data: selectedUser } = useUserQuery(value as ObjectId);
  const concatenatedList = patientList.find((p) => p.id === selectedUser?.id)
    ? patientList
    : [...patientList, ...(selectedUser ? [selectedUser] : [])];

  return (
    <Select
      clearable
      placeholder={placeholder}
      limit={20}
      searchable
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      value={value}
      onChange={(item) => onChange(item || '')}
      data={concatenatedList.flatMap((item) =>
        item.id ? [{ value: item.id, label: `${item.firstName} ${item.lastName}` }] : [],
      )}
      data-testid={`select-with-search-${testId || ''}`}
    />
  );
};
